import { Box } from '@frontend/legacy-components';

export const DeletedThumbnail = () => {
  return (
    <Box height="auto" maxHeight="100%" maxWidth="100%" color="#828282">
      FILE DELETED
    </Box>
  );
};
